import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
//import SamplePage from './Pages/SamplePage';
import DashboardPage from './Pages/Dashboard';
import Error404 from './Pages/404';
import Login from './Auth/Login';
import Register from './Auth/Register';
import ForgotPasswordPage from './Auth/ForgotPassword';
import ResetPassword from './Auth/ResetPassword';
import VerifyAccount from './Auth/VerifyAccount';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  return (
    <Route
      {...rest}
      render={props =>
        authUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={'/dashboard'} />;
  } else if (authUser && location.pathname === '/signin') {
    return <Redirect to={'/dashboard'} />;
  }

  return (
    <React.Fragment>
      <Switch>
        {/* <Route path="/sample-page" component={SamplePage} /> */}
        <RestrictedRoute path="/dashboard" component={DashboardPage} />
        <Route path="/signin" component={Login} />
        <Route path="/signup" component={Register} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route path="/reset-password/:uidb64/:token" component={ResetPassword} />
        <Route path="/verify-account/:uidb64/:token" component={VerifyAccount} />
        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
